import styled from 'styled-components';
import { COLORS, FLEX_CONTAINER, FONT_FAMILY, FONTS, size } from 'utils/styles';

export const StartRequestWrapper = styled.div`
  width: 1414px;
  background: linear-gradient(
    155.67deg,
    rgba(255, 255, 255, 0.59) -7.08%,
    rgba(255, 255, 255, 0.13) 110.41%
  );
  border: 1px solid rgba(15, 66, 90, 0.33);
  box-shadow: 0 4px 24px -1px #0f425a;
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding-top: 10px;
  padding-bottom: 20px;

  @media only screen and (max-width: ${size.desktop}) {
    width: 1200px;
  }

  @media only screen and (max-width: ${size.laptopL}) {
    width: 688px;
  }

  @media only screen and (max-width: ${size.tablet}) {
    width: 396px;
  }

  @media only screen and (max-width: ${size.mobileL}) {
    width: 302px;
  }
`;

export const StartRequestContent = styled.div`
  width: 100%;
  height: 100%;
  padding-left: 120px;
  padding-right: 120px;
  padding-top: 10px;

  @media only screen and (max-width: ${size.tablet}) {
    padding-left: 42px;
    padding-right: 42px;
  }
`;

export const IntroductionText = styled.p`
  ${FONTS.font20};
  color: ${COLORS.mainColor};
  ${FONT_FAMILY.FontRegular};

  @media only screen and (max-width: ${size.laptopL}) {
    ${FONTS.font16};
  }

  @media only screen and (max-width: ${size.mobileL}) {
    ${FONTS.font12};
  }
`;

export const IconAndButtonForStarting = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow};
  width: 100%;
  padding-right: 40px;
  padding-left: 40px;

  @media only screen and (max-width: ${size.laptopL}) {
    flex-wrap: wrap;
  } ;
`;

export const DestinationIcon = styled.img`
  @media only screen and (max-width: ${size.tablet}) {
    width: 100%;
  }
`;

export const StartYourTripWrapper = styled.div`
  width: 600px;
  height: 200px;
  ${FLEX_CONTAINER.FlexCenterRow};

  @media only screen and (max-width: ${size.mobileL}) {
    width: 100%;
  }
`;

export const StartTripButton = styled.button`
  width: 232px;
  height: 62px;
  background: ${COLORS.mainColor};
  color: ${COLORS.white};
  ${FONTS.font18};
  ${FONT_FAMILY.FontRegular};
  border-radius: 20px;
  position: relative;

  &:hover {
    background: ${COLORS.mainColor_op7};
  }

  @media only screen and (max-width: ${size.tablet}) {
    width: 190px;
    height: 50px;
    ${FONTS.font14};
  }

  @media only screen and (max-width: ${size.tablet}) {
    width: 160px;
    height: 50px;
    ${FONTS.font14};
  }
`;

export const ImgLine = styled.img`
  position: absolute;
  left: 220px;

  @media only screen and (max-width: ${size.desktop}) {
    left: 180px;
  }

  @media only screen and (max-width: ${size.tablet}) {
    left: 120px;
    width: 150px;
  }

  @media only screen and (max-width: ${size.mobileL}) {
    width: 100px;
    left: 80px;
    top: 38px;
  }
`;
